export default "__VITE_ASSET__e81256a1__"